import styles from './friend-invite-list.module.scss';
import { useState } from 'react';
import { VStack, Text } from 'native-base';

// Components
import {
  PrimaryButton,
  ModalWrapper,
  TextField,
  LocalComponentError,
  FriendListTableView,
  CustomCheckboxWrapper,
} from '../..';

// Redux
import {
  closeModal,
  useAppDispatch,
  openModal,
  useGetCurrentUserQuery,
} from '@breakroom-nx/redux';

import * as Yup from 'yup';

import { Formik, ErrorMessage } from 'formik';
import { httpsCallable } from 'firebase/functions';

// Assets
import { theme } from '@breakroom-nx/assets';
import { functions } from '@breakroom-nx/apis';

import { InputType, AccountType, Status } from '@breakroom-nx/helpers';

const InviteSchema = Yup.object().shape({
  username: Yup.string().required("Enter your friend's username"),
});

import React from 'react';
import { HStack, Spacer, View } from 'native-base';

import { UserListTableViewCell, TableView } from '../..';
import { User } from '@breakroom-nx/classes';

// Redux
import { useGetFriendsForUserWithUIDQuery } from '@breakroom-nx/redux';

/* eslint-disable-next-line */
export interface UserInviteListProps {}

export function UserInviteList(props: UserInviteListProps) {
  const appDispatch = useAppDispatch();
  const [textError, setTextError] = useState<string | undefined>(undefined);
  const [sending, setSending] = useState<boolean>(false);

  const { data: currentUser } = useGetCurrentUserQuery(null);
  const sendInvite = httpsCallable(functions, 'user-invitefriendtoapp');

  async function inviteFriendToApp(recipientUsername: string) {
    // console.log(recipientUsername);
    // if (currentUser) {
    //   await sendInvite({
    //     username: currentUser.username,
    //     name: currentUser.name,
    //     username: recipientUsername,
    //   })
    //     .then(() => {
    //       appDispatch(closeModal());
    //       appDispatch(
    //         openModal({
    //           modalType: 'Alert',
    //           modalProps: {
    //             status: Status.success,
    //             title: `Invite successfully sent!`,
    //           },
    //         })
    //       );
    //     })
    //     .catch((err) => {
    //       setTextError(`Error: ${err}`);
    //     });
    // } else {
    //   setTextError(
    //     `There was an issue authenticating your logged in state, please try again.`
    //   );
    // }
  }

  const {
    data: friends,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetFriendsForUserWithUIDQuery(currentUser!.uid);

  const [selectedFriendsCount, modifySelectedFriendsCount] = useState(0);

  const modifyCounter = (int: number) => {
    modifySelectedFriendsCount(selectedFriendsCount + int);
  };

  const checkOffSelection = (selection: string) => {};

  const renderFriends = () => {
    if (friends && friends.length > 0) {
      return friends.map((friend) => {
        return (
          <CustomCheckboxWrapper
            counterValue={selectedFriendsCount}
            onCounterChange={modifyCounter}
            onCheckboxSelect={checkOffSelection}
            setAsChecked={false}
            maxSelection={25}
            title={'Hello'}
            key={'Hello'}
            child={
              <UserListTableViewCell
                uid={friend.uid}
                username={friend.username}
                key={friend.uid}
              />
            }
          />
        );
      });
    } else {
      return;
    }
  };

  return (
    <ModalWrapper>
      <VStack
        bg={'surface.100'}
        space={3}
        textAlign={'center'}
        style={{
          borderColor: theme.colors.surface[200],
          borderWidth: 1,
          borderRadius: 25,
          shadowColor: theme.colors.surface[100],
          shadowOpacity: 0.25,
          shadowRadius: 20,
          shadowOffset: {
            width: 10,
            height: 20,
          },
          padding: 30,
        }}
      >
        <VStack space={4}>
          <LocalComponentError error={textError} />
          <VStack space={1}>
            <VStack space={1}>
              <Text
                fontFamily={'heading'}
                fontSize={23}
                color={'primary.400'}
                fontWeight={600}
                mb={'3px'}
              >
                {`Invite ${
                  selectedFriendsCount == 0
                    ? ''
                    : `${selectedFriendsCount} ${
                        selectedFriendsCount === 1 ? 'Friend' : 'Friends'
                      }`
                }`}
              </Text>
            </VStack>
          </VStack>

          <Formik
            initialValues={{
              username: '',
            }}
            validationSchema={InviteSchema}
            onSubmit={async (values, { setSubmitting }) => {
              setSending(true);
              inviteFriendToApp(values.username);
            }}
          >
            {({
              validateOnBlur = true,
              handleChange,
              handleBlur,
              handleSubmit,
              values,
            }) => (
              <VStack height={'full'} flex={1}>
                <VStack space={'3'} width={'full'}>
                  <TextField
                    type={InputType.Username}
                    onChangeText={handleChange('username')}
                    onBlur={handleBlur('username')}
                    value={values.username}
                    color={'primary.400'}
                    autoFocus
                  />
                  <Text variant={'error'}>
                    <ErrorMessage name="username" />
                  </Text>
                </VStack>
                <VStack space={'3'} width={'full'}>
                  <TableView
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    isError={isError}
                    error={error}
                    noData={!friends || friends.length < 1}
                    noDataString={'Broken'}
                    onRefetch={refetch}
                    px={0}
                    pb={0}
                  >
                    {renderFriends()}
                  </TableView>
                </VStack>
                <VStack mt={5} space={4} width={'full'} alignItems={'center'}>
                  <PrimaryButton
                    disabled={values.username === '' || sending || !currentUser}
                    text={'Invite'}
                    bg={'primary.400'}
                    color={'surface.100'}
                    isLoading={sending}
                    onPress={handleSubmit}
                    width={'100%'}
                  />
                </VStack>
              </VStack>
            )}
          </Formik>
        </VStack>
      </VStack>
    </ModalWrapper>
  );
}

export default UserInviteList;
